/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

export type TimeFormatFunction = (value: Date) => string;

export type TimeRangeFormatFunction = (values: (Date | number | undefined | null)[]) => string;

/**
 * search for `builtin_time_grains` in incubator-superset/superset/db_engine_specs/base.py
 */
export const TimeGranularity = {
    DATE: "date",
    SECOND: "PT1S",
    MINUTE: "PT1M",
    FIVE_MINUTES: "PT5M",
    TEN_MINUTES: "PT10M",
    FIFTEEN_MINUTES: "PT15M",
    THIRTY_MINUTES: "PT30M",
    HOUR: "PT1H",
    DAY: "P1D",
    WEEK: "P1W",
    WEEK_STARTING_SUNDAY: "1969-12-28T00:00:00Z/P1W",
    WEEK_STARTING_MONDAY: "1969-12-29T00:00:00Z/P1W",
    WEEK_ENDING_SATURDAY: "P1W/1970-01-03T00:00:00Z",
    WEEK_ENDING_SUNDAY: "P1W/1970-01-04T00:00:00Z",
    MONTH: "P1M",
    QUARTER: "P3M",
    YEAR: "P1Y",
} as const;

type ValueOf<T> = T[keyof T];

export type TimeGranularity = ValueOf<typeof TimeGranularity>;
